import { Receipt, ReceiptItem } from '../../types/receipts';
import { formatMoney } from '../../helpers/formatters';

export const getReceiptStoreName = (receipt: Receipt) => {
    return receipt.store.name || receipt.store.business_name;
};

export const getReceiptNetAmount = (receipt: Receipt, lng: string) => {
    if (!receipt.net_amount || !receipt.currency) return 'N/A';
    return formatMoney(lng, receipt.net_amount, receipt.currency);
};

export const getReceiptItemNetAmount = (receiptItem: ReceiptItem, lng: string, currency?: string) => {
    if (!receiptItem.net_amount || !currency) return 'N/A';
    return formatMoney(lng, receiptItem.net_amount, currency);
};

export const filterReceiptsByStoreAndItemName = (receipts: Receipt[], q: string) => {
    const re = new RegExp(q, 'i');
    return receipts.filter((r: Receipt) => {
        const items = r.items?.map((i: ReceiptItem) => i.description).join('___');
        return re.test(r.store.name || r.store.business_name || '') || re.test(items || '');
    });
};
